<template>
  <div
    class="main-view"
  >
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>


export default {
  name: 'MainView',
  data() {
    return {
      state: 'released',
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  watch: {
    routeName() {
      if (this.$store.state.isMobile) window.scrollTo(0, 0);
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      if (window.innerWidth <= parseInt(this.$tokens.bp_mobile, 0)) {
        this.$store.commit('setMobile', true);
      } else {
        this.$store.commit('setMobile', false);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main-view {
  position: relative;
  width: 100%;
  transition: background-color 100ms ease-out;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
